import React from 'react';
import Interweave from 'interweave';

import { Avatar, IconButton } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';

import { pink } from '@mui/material/colors';

function ImageBlockView({idx, block, allowEditing, onEdit}) {
	//console.log("ImageBlockView: allowEditing = " + allowEditing);
	console.log("ImageBlockView: block.type = " + block.type);

	function getEditButton() {
		if (allowEditing) {
			return (
				<IconButton
					style={{
						position:"absolute",
						top:20,
						left:20,
					}}
					size="large"
					onClick={e => onEdit(block)}
				>
					<Avatar sx={{bgcolor:pink[500]}}>
						<EditIcon />
					</Avatar>
				</IconButton>
			);
		}
		return null;
	}

	const style = {
		transform: `translateX(${block.translationX}%) scale(${block.scale})`,
	};

	return (
		<div
			style={{
				width:'100%',
				backgroundColor: block.backgroundColor,
				overflow:'hidden',
				position:'relative',
			}}
		>
			<div id={block.name} style={style}>
				<Interweave content={block.data ? block.data : ''}/>
			</div>
            {getEditButton()}
		</div>
	);
}

export default ImageBlockView;
